import { useState } from 'react'
import { useRouter } from 'next/router'

import styles from './Layout.module.scss'

import useCheckBreakpoint from 'lib/checkBreakpoint'

import HeaderComponent from '../headers'
import SideMenuComponent from '../menus/SideMenuComponent'
import FooterComponent from '../footers'
interface Props {
  children: React.ReactNode
}

const Layout: React.FC<Props> = ({ children }: Props): JSX.Element => {
  const { pathname } = useRouter()

  const { isMobile } = useCheckBreakpoint()

  const [isOpenMenu, setIsOpenMenu] = useState<boolean>(false)

  return (
    <>
      <HeaderComponent
        onPressHamburgerMenu={() => setIsOpenMenu(!isOpenMenu)}
        isOpenMenu={isOpenMenu}
      />
      {isOpenMenu && <SideMenuComponent />}
      <main className={`${styles.main} ${isOpenMenu ? styles.openMenu : ''}`}>{children}</main>
      {pathname in
        {
          '/': '/',
          '/space/[...slug]': '/space/[...slug]',
          '/spaces/[...id]': '/spaces/[...id]',
          '/[country]': '/[country]',
          '/[country]/city/[...slug]': '/[country]/city/[...slug]',
          '/users/delete': '/users/delete',
          '/locker/[id]': '/locker/[id]',
          '/pudo/[id]': '/pudo/[id]',
        } && <FooterComponent />}
    </>
  )
}

export default Layout
